// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"206":"022986b2","367":"538fa126"}[chunkId] + ".css";
};